/* global Reepay */
import UserService from "../../services/UserService";
import { React, useEffect, useState } from "react";

const BillwerkStrex = ({ isActive, currentToken, subscription }) => {
  console.log("isActive", isActive);
  const [transactionID, setTransactionID] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [disableButton, setDisableButton] = useState(false);
  const [smsCode, setSmsCode] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const resendSMSCode = () => {
    UserService.sendBillwerkStrexSMS(currentToken.access_token).then(
      (response) => {
        console.log("response 3", response);
        setTransactionID(response.transactionId);
        document.getElementById("sms_code").value = "";
        document.getElementById("invalid_sms_code").style.display = "none";
      }
    );
  };

  const confirmSubscriptionBillwekrStrex = () => {
    // const smsCode = document.getElementById("sms_code").value;
    setDisableButton(true);
    UserService.confirmSubscriptionBillwekrStrex(
      currentToken.access_token,
      transactionID,
      smsCode
    ).then(
      (response) => {
        UserService.setBeatFrisbiiIntent(
          currentToken.access_token,
          "offline_other",
          subscription.product_id
        ).then((response) => {
          setClientSecret(response.clientSecret);
          document.getElementById("reepay_container").style.display = "block";
          document.getElementById("strex_sms_container").style.display = "none";
          //window.location.reload();
          //console.log("response 4", response);
        });
      },
      (error) => {
        setDisableButton(false);
        console.log("error 333", error);
      }
    );
  };
  useEffect(() => {
    //console.log("clientSecret  1", clientSecret);
    if (
      !document.querySelector(
        `script[src="https://checkout.reepay.com/checkout.js"]`
      )
    ) {
      //console.log("clientSecret 2", clientSecret);
      const script = document.createElement("script");
      script.src = "https://checkout.reepay.com/checkout.js";
      script.async = true;
      script.onload = () => initializeRReepay(); // Initialize after loading
      document.body.appendChild(script);
    } else {
      //console.log("clientSecret 5", clientSecret);
      initializeRReepay(); // If already exists, initialize directly
    }
    //console.log("clientSecret 3", clientSecret);
    function initializeRReepay() {
      //console.log("clientSecret 6", clientSecret);
      if (window.Reepay) {
        //console.log("clientSecret 7", clientSecret);

        //var rp = window.Reepay.embeddedCheckout(clientSecret, "rp_container");
        var reep = new window.Reepay.EmbeddedCheckout(clientSecret, {
          html_element: "reepay_container",
        });
        //console.log("clientSecret 8", clientSecret);

        reep.addEventHandler(window.Reepay.Event.Accept, function (data) {
          UserService.createBeatFrisbiiSubscription(
            currentToken.access_token,
            data.payment_method
          )
            .then((response) => {
              //console.log("response 1", response);
            })
            .error((error) => {
              //console.log("error 1", error);
              //console.log("clientSecret 9", clientSecret);
            });
        });
      }
    }
    //console.log("clientSecret 4", clientSecret);
  }, [clientSecret, currentToken.access_token]);
  useEffect(() => {
    if (isActive) {
      UserService.sendBillwerkStrexSMS(currentToken.access_token)
        .then((response) => {
          console.log("response 2", response);

          setTransactionID(response.transactionId);
        })
        .catch((error) => {
          console.log("error 2", error);
        });
    }
  }, [isActive]);
  return (
    <>
      <div
        id="reepay_container"
        style={{ height: "450px", display: "none" }}
      ></div>
      <div
        id="reepay_success_content"
        style={{ display: "none", padding: "25px", textAlign: "center" }}
      >
        <h5>Betalingsmåte endret</h5>
      </div>
      <div id="strex_sms_container" style={{ padding: "20px" }}>
        <div>
          <>Du vil nå motta en ny kode på SMS. Det kan ta opptil 30 sekunder.</>
          <br />
          <div className="input-group input-group">
            <input
              type="text"
              id="sms_code"
              className="fabel-input form-control"
              maxLength={4}
              onChange={(e) => {
                setSmsCode(e.target.value);
              }}
              onInput={(e) => {
                e.target.value = e.target.value
                  .replace(/[^0-9]/g, "")
                  .slice(0, 4);
                setSmsCode(e.target.value);
              }}
            />
          </div>
          <div className="input-group input-group-btn-container input-group">
            <button
              type="button"
              disabled={disableButton}
              onClick={confirmSubscriptionBillwekrStrex}
              className="confirm-password-btn btn-fabel btn btn-primary"
            >
              Bekreft sms-kode
            </button>
          </div>
        </div>
        <div
          id="invalid_sms_code"
          style={{ display: "none" }}
          className="error-msg"
        >
          SMS-koden er feil eller utløpt.{" "}
          <span
            onClick={resendSMSCode}
            style={{ cursor: "pointer", fontWeight: "bold" }}
          >
            Send på nytt
          </span>
        </div>
      </div>
    </>
  );
};

export default BillwerkStrex;
